import * as React from 'react';

import { cn } from './utils';

export type InputProps = {
  invalid?: boolean;
  /** When true, defers onChange to blur event for expensive validation */
  onChangeOnBlur?: boolean;
} & React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, invalid = false, value, onChangeOnBlur, onChange, onBlur, ...props }, ref) => {
    const [controlledState, setControlledState] = React.useState(value);

    React.useEffect(() => {
      if (onChangeOnBlur) setControlledState(value);
    }, [onChangeOnBlur, value]);

    return (
      <input
        type={type}
        aria-invalid={invalid || undefined}
        className={cn(
          'flex w-full rounded-md border border-input bg-background px-3 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 focus-visible:border-focus transition-colors',
          invalid && 'border-support-error',
          className,
        )}
        ref={ref}
        value={onChangeOnBlur ? controlledState : value}
        onChange={e => {
          if (onChangeOnBlur) {
            setControlledState(e.target.value);
            return;
          }
          onChange?.(e);
        }}
        onBlur={e => {
          onBlur?.(e);
          if (onChangeOnBlur) onChange?.(e);
        }}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
